@if (selectedUser?.id) {
  <dl class="px-2">
    <dt>User</dt>
    <dd class="d-flex gap-2 align-items-center">
      <div>
        {{ selectedUser?.full_name }}
      </div>
      <div
        class="edit-button"
        (click)="onSelectUser({}); shiftFocus(userLookupFieldId)"
      ></div>
    </dd>
  </dl>
} @else {
  <gtapp-auto-complete
    [data]="userLookupDataList"
    placeHolder="Search User"
    searchKeyword="full_name"
    [initialValue]="selectedUser?.full_name"
    [itemTemplate]="assigneeListTemplate"
    (inputChanged)="searchUsers($event)"
    (selected)="onSelectUser($event)"
    [enableCloseOption]="true"
    [inputId]="userLookupFieldId"
    (fieldCleared)="shiftFocus(userLookupFieldId)"
    (inputFocused)="inputFocused()"
  >
  </gtapp-auto-complete>
  <ng-template #assigneeListTemplate let-item>
    <div class="d-flex gap-2 flex-wrap">
      <span> {{ item?.full_name }} </span>
      @if (item?.access_status === 2) {
        <div
          class="text-warning-emphasis small-font bg-white rounded my-auto border px-2 fw-semibold"
        >
          Casual
        </div>
      }
    </div>

    @if (item?.subcontractors?.length) {
      <div class="small text-secondary">
        🟧Subcontractor:
        <span class="subcontractor-name">{{ item?.subcontractors }}</span>
      </div>
    }
  </ng-template>
}
